import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player/vimeo";
import iconone from './../../assets/icons/teens/1.svg'
import icorwo from './../../assets/icons/teens/2.svg'
import icothre from './../../assets/icons/teens/3.svg'
import icon4 from './../../assets/icons/teens/4.svg'
import icon5 from './../../assets/icons/teens/5.svg'
import PlayBtn from './../../assets/icons/teens/play.svg'
import "./VideoContainer.css";

interface VideoContainerProps {
  videoThumbnail: string;
  videoUrl: string;
}

const VideoContainer: React.FC<VideoContainerProps> = ({
  videoThumbnail,
  videoUrl,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const { t } = useTranslation();

  const assessmentSteps = [
    { icon: iconone, title: t("assessment_1_title"), description: t("assessment_1_description") },
    { icon: icorwo, title: t("assessment_2_title"), description: t("assessment_2_description") },
    { icon: icothre, title: t("assessment_3_title"), description: t("assessment_3_description") },
    { icon: icon4, title: t("assessment_4_title"), description: t("assessment_4_description") },
    { icon: icon5, title: t("assessment_5_title"), description: t("assessment_5_description") },
  ];

  return (
    <div className="video-assessment-wrapper">
      {/* Video Section */}
      <div className="video-container">
        <div className="video-wrapper">
          {isPlaying ? (
            <ReactPlayer
              url={videoUrl}
              playing
              controls
              width="100%"
              height="380px"
              className="video-player"
            />
          ) : (
            <div className="video-thumbnail-container" onClick={() => setIsPlaying(true)}>
              <img src={videoThumbnail} alt="Course Preview" className="video-thumbnail" />
              <div className="play-button">
                <span>
                  <img src={PlayBtn} alt=" " className="play-button" />
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Assessment Content Section */}
      <div className="assessment-container">
        <h2 className="assessment-title">{t("assessment_title2")}</h2>

        {assessmentSteps.map((step, index) => (
          <div className="assessment-item" key={index}>
            <img src={step.icon} alt="Icon" className="assessment-icon" />
            <div className="assessment-container-item">
              <p className="assessment-heading">{step.title}</p>
              <p className="assessment-description">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoContainer;
